import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-data-state',
    templateUrl: './data-state.component.html',
    styleUrl: './data-state.component.scss',
    standalone: false
})
export class DataStateComponent {
  @Input() loading : boolean | null = false;
  @Input() error : boolean = false;
  @Input() errorMessage : string = "Une erreur s'est produite lors du chargement des données.";
  @Input() height?: number;

  @ContentChild('dataError', { read: TemplateRef })customErrorTpl?: TemplateRef<any>;
}
